export default __webpack_public_path__ + "static/Mike.Allen_social-28ef56ece7ef62d63f2a72e120555ace.jpg";